var map = {
	"./dependencies.js": 39,
	"./publisher.js": 140,
	"./stylus.js": 145
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38;


//////////////////
// WEBPACK FOOTER
// ./dependencies (\/|\\)(?!_)[\w\.\-\\]+\.js$
// module id = 38
// module chunks = 5